import React from "react";
import './styles/Contact.scss';
import config from "../config";
// import { Link } from 'react-router-dom';
// import { ArrowBack } from "@mui/icons-material";

const Contact = () => {
    return (
        <div id="contact" className="contact">
            <p>
                <a href={`mailto:${config.emailAddress}`}><b> Email </b></a>
                me your thoughts!
            </p>
            {/* <Link to='/'>
                    <ArrowBack className="arrow" />
            </Link>
            <h2 className="contact__title">Contact Me</h2>
            <div className="contact__form">
                <input type="text" placeholder="Your Name" className="contact__input" />
                <input type="email" placeholder="Your Email" className="contact__input" />
                <textarea placeholder="Your Message" className="contact__textarea"></textarea>
                <button type="submit" className="contact__button">Send Message</button>
            </div> */}
        </div>
    );
}

export default Contact;